<template>
    <div v-if="emailEnabled" class="btn-group">
        <button type="button" class="btn btn-sm btn-primary dropdown-toggle font-weight-bold" data-toggle="dropdown" title="Submit Documents">
            SUBMIT
        </button>
        <div class="dropdown-menu font-small">
            <a class="dropdown-item my-0 py-0" href="javascript:void(0)" @click="$emit('clickfax')">
                <i class="fas fa-fax text-primary submit-icon"></i> Fax
            </a>
            <div class="dropdown-divider my-1 py-0"></div>
            <a class="dropdown-item my-0 py-0" href="javascript:void(0)" @click="$emit('clickemail')">
                <span class="fa-stack secure-email">
                    <i class="fas fa-envelope fa-stack-2x text-primary submit-icon"></i>
                    <i class="fas fa-lock fa-stack-1x lock"></i>                                                
                </span>                                
                <span class="secure-email-text">Secure Email</span>
            </a>
        </div>
    </div>
    <button v-else type="button" class="btn btn-sm btn-primary font-weight-bold" title="Submit Documents" @click="$emit('clickfax')">
        SUBMIT
    </button>   
</template>

<script>
export default {
    props: {
        emailEnabled: Boolean
    }
}
</script>

<style scoped>
    .font-small {
        font-size: .95em;
    }    

    .submit-icon {
        font-size: 1.2em;
    }

    .secure-email {
        position: relative;
        top: 4px;
        left: -5px;
    }

    .secure-email-text {
        position: relative;
        left: -9px;
    }

    .lock {
        position: relative;
        top: 3px;
        left: 7px;
        color: #bcbcbc;
        font-size: 0.75em;
    }
</style>